var map = {
	"./Advertisement/router.js": 85058,
	"./AgentManagement/router.js": 62179,
	"./AllCommodity/router.js": 5629,
	"./ApiTest/router.js": 87021,
	"./Approval/router.js": 69084,
	"./BankReconciliation/router.js": 37972,
	"./Billing/Meter/Report/router.js": 15937,
	"./Billing/Rental/Report/MY_004/router.js": 71620,
	"./Billing/Rental/Report/MY_005/router.js": 10485,
	"./Billing/Rental/Report/MY_006/router.js": 6422,
	"./Billing/Rental/Report/MY_008/router.js": 25456,
	"./Billing/Rental/Report/MY_009/router.js": 79025,
	"./Billing/Rental/Report/MY_010/router.js": 95603,
	"./Billing/Rental/Report/NayPyiTaw/router.js": 35501,
	"./Billing/Rental/Report/Yangon/router.js": 88351,
	"./Billing/router.js": 7808,
	"./BlackLists/router.js": 25421,
	"./BusinessRule/router.js": 26069,
	"./BusinessSwitch/router.js": 43883,
	"./CampaignList/router.js": 57111,
	"./Canal/router.js": 6888,
	"./Chat/router.js": 44467,
	"./CouponList/CouponBudget/router.js": 60041,
	"./CouponList/router.js": 62339,
	"./Customer/router.js": 93753,
	"./DPS/router.js": 46938,
	"./Dashboard/router.js": 85673,
	"./Emerald/router.js": 37721,
	"./EvaluationStatistics/router.js": 33726,
	"./FeedbackAndSuggestions/router.js": 98786,
	"./Financial/router.js": 96408,
	"./GiftCardAndGameShop/router.js": 76916,
	"./Home/router.js": 50928,
	"./IPAccessControl/router.js": 50841,
	"./Live/router.js": 68407,
	"./MerchantManage/router.js": 31712,
	"./MobileTopup/router.js": 79609,
	"./OpenApi/router.js": 13261,
	"./PointBudget/router.js": 98944,
	"./QuestionnaireList/router.js": 52074,
	"./Report/router.js": 37063,
	"./SalaryAgency/router.js": 58990,
	"./ServiceFeeMgmt/router.js": 10121,
	"./SuspiciousMonitoring/router.js": 99038,
	"./SystemManage/router.js": 23923,
	"./SystemMessage/router.js": 61673,
	"./SystemSetting/router.js": 39548,
	"./Ticket/router.js": 96357,
	"./TransactionLimitMgmt/router.js": 56747,
	"./TransactionMonitoring/router.js": 20279,
	"./Translation/router.js": 74208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66279;